import React from 'react';

import {
  ALL_STATUSES,
  REDEEMED,
  NOT_REDEEMED,
} from '../consts';

// styles
import styles from '../../../my-events/status-filter-dropdown/styles-module.css';

// Messages
import messages from '../locale';

const StatusFilterDropdown = (props) => {
  return (
    <div className={styles.wrapper}>
      {props.customIcon}
      <select className={styles.dropdown}
        value={props.selectedStatus}
        onChange={(e) => props.handleStatusFilterChange(e.target.value)}
      >
        <option key={ALL_STATUSES} value={ALL_STATUSES}>
          {props.intl.formatMessage(messages.allStatuses)}
        </option>
        <option key={NOT_REDEEMED} value={NOT_REDEEMED}>
          {props.intl.formatMessage(messages.notRedeemed)}
        </option>
        <option key={REDEEMED} value={REDEEMED}>
          {props.intl.formatMessage(messages.redeemed)}
        </option>
      </select>
    </div>
  );
};

export default StatusFilterDropdown;
